/**
* Expose the service definitions
*/
export * from './EVA.Authentication.OpenID.Services.js';
//# sourceMappingURL=eva-services-authentication-openid.js.map